import { OTHERS_DOMAIN_NAME } from "../../../../keyword-analysis/TotalTrafficPage/Graph/GraphData";
import { ChangeTooltip } from "@similarweb/ui-components";
import { getTooltipHeader } from "app/UtilitiesAndConstants/UtilitiesComponents/chartTooltipHeaderWithMTDSupport";
import { shuffle } from "app/UtilitiesAndConstants/UtilityFunctions/sort";
import styled, { css } from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { setFontVariant } from "@similarweb/styles";
import type { granularityNameToMomentUnit } from "app/UtilitiesAndConstants/Constants/Moment";

const { carbon } = colorsPalettes;

interface IChartTooltipProps {
    yFormatter: ({ value }: { value: any }) => any;
    timeGranularity: keyof typeof granularityNameToMomentUnit;
    lastSupportedDate: string;
    points: Array<{ series: { name: string }; y: number }>;
    point?: { name: string };
    othersDomainPointPosition?: "top" | "bottom";
    shouldSkipSorting?: boolean;
    subtitleWidth?: string;
}

export const Subtitle = styled.span<{ width?: string }>`
    vertical-align: middle;
    margin-left: 11px;
    line-height: 16px;
    text-overflow: ellipsis;
    overflow: hidden;
    ${setFontVariant("caption", carbon[300])};
    ${({ width }) =>
        width &&
        css`
            width: ${width};
        `}
`;

export const ChartTooltip = (props: IChartTooltipProps) => {
    const {
        yFormatter,
        timeGranularity,
        lastSupportedDate,
        points: pointsArgs,
        point,
        shouldSkipSorting = false,
        othersDomainPointPosition = "bottom",
        subtitleWidth,
    } = props;
    const filteredPoints = pointsArgs.filter(({ series }) => series.name !== OTHERS_DOMAIN_NAME);

    let points = shouldSkipSorting
        ? filteredPoints
        : shuffle(filteredPoints).sort(({ y: y1 }, { y: y2 }) => {
              return y1 < y2 ? 1 : -1;
          });

    const others = pointsArgs.find(({ series }) => series.name === OTHERS_DOMAIN_NAME);
    if (others) {
        points = othersDomainPointPosition === "top" ? [others, ...points] : [...points, others];
    }
    const changeTooltipProp = ({ y, series }) => {
        const subtitle = series.userOptions?.subtitle;
        return {
            value: yFormatter({ value: y }),
            color: series.color,
            displayName: series.name,
            isBold: point?.name === series.name,
            subtitle: subtitle ? <Subtitle width={subtitleWidth}>{subtitle}</Subtitle> : null,
            itemHeight: subtitle ? 34 : 24,
        };
    };
    const changeTooltipProps = {
        header: getTooltipHeader(timeGranularity, points, lastSupportedDate),
        tableHeaders: [
            { position: 0, displayName: "Domain" },
            { position: 1, displayName: "Traffic share" },
        ],
        tableRows: points.map(changeTooltipProp),
        showChangeColumn: false,
    };
    return <ChangeTooltip {...changeTooltipProps} />;
};
